export const beeyTheme = {
    cssVar: true,
    token: {
        // PRIMARY COLORS
        colorPrimary: '#ffae43',
        colorLink: 'var(--ant-color-primary)',
        colorPrimaryHover: '#ffbb62',
        colorPrimaryActive: 'var(--ant-color-primary-hover)',
        colorPrimaryTextActive: 'var(--ant-color-primary-hover)',
        colorLinkHover: 'var(--ant-color-primary-hover)',
        colorLinkActive: 'var(--ant-color-primary-hover)',
        // SECONDARY CONTROLS COLOR: Selected menu, circle buttons
        colorPrimaryBorder: '#ffdaa9',
        colorPrimaryBorderHover: '#ffcf8f',
        // ACCENT COLORS & INFO: Switches, radio, checkbox, tags, badges, progress
        colorInfo: '#90d7ff',
        colorInfoHover: '#b9e6ff',
        colorInfoActive: 'var(--ant-color-info-hover)',
        colorInfoTextActive: 'var(--ant-color-info-hover)',
        colorInfoBg: '#f1faff', // Table row hover
        // SEMANTIC COLORS
        colorSuccess: '#9bd920',
        colorSuccessActive: '#d0f272',
        colorSuccessTextActive: 'var(--ant-color-success-active)',
        colorWarning: '#FFCA00',
        colorWarningActive: '#FFE852',
        colorWarningTextActive: 'var(--ant-color-warning-active)',
        colorError: '#ff7d4b',
        colorErrorActive: '#ff9f73',
        colorErrorTextActive: 'var(--ant-color-error-active)',
        // TEXT and ICON COLORS
        colorTextBase: '#444444',
        colorText: 'var(--ant-color-text-base)',
        colorTextSecondary: '#666666',
        colorTextDisabled: '#bababa',
        colorTextDescription: 'var(--ant-color-text-disabled)',
        colorIcon: 'var(--ant-color-text-base)',
        // NEUTRALS
        colorBorder: '#D9D9D9',
        colorBgContainerDisabled: '#eeeeee',
        colorFillTertiary: '#f6f6f6', // light bg gray
        // FONTS
        fontFamily: "'Open Sans', sans-serif",
        fontSize: 15,
        fontSizeSM: 14,
        fontSizeLG: 17,
        fontSizeHeading1: 23,
        fontSizeHeading2: 18,
        fontSizeHeading3: 16,
        fontSizeHeading4: 15,
        fontWeightStrong: 600,
        // OTHER
        borderRadius: 16,
        borderRadiusSM: 4,
        borderRadiusLG: 20,
        boxShadow: 'var(--box-shadow)',
        marginXXS: 0,
    },
    components: {
        Button: {
            borderRadiusSM: 40,
            borderRadius: 40,
            borderColorDisabled: 'transparent',
            colorLink: 'var(--ant-color-primary)',
            colorLinkHover: 'var(--ant-color-primary-hover)',
            paddingInlineSM: 10,
            controlHeightSM: 27,
        },
        Modal: {
            titleFontSize: 17,
            contentPadding: '16px 30px',
        },
        Menu: {
            darkItemColor: 'var(--ant-color-text-primary)',
            darkItemHoverBg: 'transparent',
            darkItemHoverColor: 'var(--ant-color-primary-hover)',
            darkItemSelectedColor: 'var(--ant-color-text-primary)',
            darkItemBg: 'transparent',
            darkSubMenuItemBg: 'white',
            itemHoverBg: 'transparent',
            activeBarBorderWidth: 0,
            itemPaddingInline: 0,
            itemMarginInline: 0,
            subMenuItemBg: 'white',
        },
        Layout: {
            siderBg: 'transparent',
            bodyBg: 'linear-gradient(180deg, #fdfaf6 0%, #f7f0e4 56%, #ffe9cb 100%)',
            headerBg: 'transparent',
            headerColor: 'var(--ant-color-text-base)',
        },
        Table: {
            cellPaddingBlock: 5,
            cellPaddingInline: 5,
            headerColor: 'var(--ant-color-text-base)',
            headerFilterHoverBg: 'transparent',
            headerSplitColor: 'transparent',
            headerBg: 'var(--ant-color-fill-tertiary)',
            rowHoverBg: 'var(--ant-color-info-bg)',
            rowExpandedBg: '#fafafa',
            headerIconColor: 'var(--ant-color-text-secondary)',
        },
        Tag: {
            colorBorder: 'transparent',
            borderRadiusSM: 40,
            colorPrimary: 'var(--ant-color-info)',
            colorPrimaryHover: 'var(--ant-color-info-hover)',
        },
        Card: {
            colorBorderSecondary: 'transparent',
            paddingLg: '16px',
        },
        Badge: {
            colorError: 'var(--ant-color-info)',
            colorErrorHover: 'var(--ant-color-info-hover)',
        },
        Progress: {
            defaultColor: 'var(--ant-color-info)',
        },
        Switch: {
            colorPrimary: 'var(--ant-color-info)',
            colorPrimaryBorder: 'var(--ant-color-info)',
            colorPrimaryHover: 'var(--ant-color-info-hover)',
        },
        Radio: {
            radioBgColor: 'var(--ant-color-info)',
            buttonSolidCheckedHoverBg: 'var(--ant-color-info-hover)',
            buttonSolidCheckedBg: 'var(--ant-color-info)',
        },
        Slider: {
            trackBg: 'var(--ant-color-info)',
            handleActiveColor: 'var(--ant-color-info-hover)',
            handleColor: 'var(--ant-color-info)',
            dotActiveBorderColor: 'var(--ant-color-info-hover)',
            colorPrimaryBorderHover: 'var(--ant-color-info-hover)',
        },
        Alert: {
            colorErrorBorder: 'transparent',
            colorSuccessBorder: 'transparent',
            colorInfoBorder: 'transparent',
            colorWarningBorder: 'transparent',
            fontSizeLG: 15,
        },
        Form: {
            itemMarginBottom: 15,
            labelFontSize: 15,
            verticalLabelPadding: 4,
        },
        Input: {
            activeBg: 'white',
            hoverBg: 'white',
        },
        Collapse: {
            contentBg: 'white',
            headerBg: 'white',
            headerPadding: 0,
            contentPadding: 0,
        },
        Select: {
            borderRadiusSM: 14,
        },
        Steps: {
            iconSizeSM: 24,
        },
        Pagination: {
            colorBorder: 'transparent',
        },
        Upload: {
            actionsColor: 'var(--ant-color-icon)',
        },
        Rate: {
            starColor: 'var(--ant-color-info)',
        },
    },
};
export const greyTheme = Object.assign(Object.assign({}, beeyTheme), { token: Object.assign(Object.assign({}, beeyTheme.token), { 
        // PRIMARY COLORS: buttons, links
        colorPrimary: '#3e3d3dff', colorPrimaryHover: 'black', linkDecoration: 'underline', linkHoverDecoration: 'underline', linkFocusDecoration: 'underline', 
        // SECONDARY CONTROLS COLOR: Selected menu, circle buttons
        colorTextSecondary: '#a2a2a2ff', colorPrimaryBorder: '#737373ff', colorPrimaryBorderHover: '#7a7a7aff', colorPrimaryBg: '#f7f7f7ff', controlItemBgActive: '#fafafaff', controlItemBgHover: 'var(--ant-control-item-bg-active)', controlItemBgActiveHover: 'var(--ant-color-primary-bg)', colorBgSpotlight: '#1f1f1fe6', colorSplit: '#82828266', 
        // ACCENT COLORS & INFO: Switches, radio, checkbox, tags, badges, progress
        colorInfo: '#2c82be', colorInfoHover: '#3294d2', colorInfoBg: '#e2eff7ff', boxShadowSecondary: '0 0 9px 1px rgba(5, 5, 5, 0.4)', 
        // SEMANTIC COLORS
        colorSuccess: '#2E7D32', colorWarning: '#FFE600', colorError: '#B00020' }), components: Object.assign(Object.assign({}, beeyTheme.components), { Badge: {
            colorError: 'var(--ant-color-primary)',
            colorErrorHover: 'var(--ant-color-primary-hover)',
        }, Drawer: {
            colorBgElevated: 'var(--ant-color-primary)',
        }, Menu: Object.assign(Object.assign({}, beeyTheme.components.Menu), { colorPrimaryHover: 'var(--ant-control-item-bg-active)', darkItemColor: 'var(--ant-color-text-secondary)', darkItemHoverColor: 'white', darkItemSelectedColor: 'white', darkSubMenuItemBg: 'var(--ant-color-primary)', itemHoverBg: 'transparent', activeBarBorderWidth: 0, itemPaddingInline: 0, itemMarginInline: 0 }), Layout: Object.assign(Object.assign({}, beeyTheme.components.Layout), { bodyBg: 'linear-gradient(180deg, #4b4b4bff 0%, #3f3f3fff 56%, #2b2b2bff 100%)' }), Message: {
            boxShadow: 'var(--ant-box-shadow-secondary)',
        }, Progress: {
            defaultColor: 'var(--ant-color-primary)',
        }, Select: Object.assign(Object.assign({}, beeyTheme.components.Select), { optionSelectedBg: 'var(--ant-control-item-bg-active)' }), Slider: {
            trackBg: 'var(--ant-color-primary)',
            handleActiveColor: 'var(--ant-color-primary-hover)',
            handleColor: 'var(--ant-color-primary)',
            dotActiveBorderColor: 'var(--ant-color-primary-hover)',
            colorPrimaryBorderHover: 'var(--ant-color-primary-hover)',
        }, Radio: {
            radioBgColor: 'var(--ant-color-primary)',
            buttonSolidCheckedHoverBg: 'var(--ant-color-primary-hover)',
            buttonSolidCheckedBg: 'var(--ant-color-primary)',
        }, Rate: {
            starColor: 'var(--ant-color-primary)',
        }, Table: Object.assign(Object.assign({}, beeyTheme.components.Table), { rowSelectedBg: 'var(--ant-control-item-bg-active)', rowSelectedHoverBg: 'var(--ant-color-primary-bg)', rowHoverBg: 'var(--ant-color-primary-bg)' }), Tag: Object.assign(Object.assign({}, beeyTheme.components.Tag), { colorBorder: 'transparent', colorPrimary: '#3e3d3dff', colorPrimaryHover: 'black' }), Switch: {
            colorPrimary: '#3e3d3dff',
            colorPrimaryBorder: '#3e3d3dff',
            colorPrimaryHover: 'black',
        } }) });
export const createDynamicGreyTheme = (headerBg, headerColor) => (Object.assign(Object.assign({}, greyTheme), { components: Object.assign(Object.assign({}, greyTheme.components), { Layout: Object.assign(Object.assign({}, greyTheme.components.Layout), { headerBg: headerBg !== null && headerBg !== void 0 ? headerBg : 'var(--ant-color-primary)', headerColor: headerColor !== null && headerColor !== void 0 ? headerColor : 'white' }) }) }));
